import { jsonFetch } from "../client/api/api"
import { debounce } from "../utils/timer"

let container = document.querySelector('#all-publications')
let loading = false
let loader = document.getElementById('loading')
let btnCard = document.querySelectorAll('.leo-card__btn');

btnCard?.forEach(function (btn) {
    btn.addEventListener('click', function () {
        btn.classList.toggle('leo-card__btn--active')
        let abstract = btn.nextElementSibling;
        abstract.classList.toggle('leo-card__abstract--active');
    })
})


if(!container?.classList.contains('no-ajax')){

    window.addEventListener('scroll', debounce((e) => {

        var rect = container?.getBoundingClientRect();

        if(!rect){
            return
        }

        var offset = { 
            top: rect.top + window.scrollY, 
            left: rect.left + window.scrollX, 
        };

        if(!loading && window.scrollY + window.outerHeight >= offset.top + container.offsetHeight) {
            loading = true
            loader.classList.add('active')
            let page = document.getElementById('infinite_scroll').dataset.paged
            let nextPage = parseInt(page) + 1
            document.getElementById('infinite_scroll').dataset.paged = nextPage

            getPublications(nextPage)

        }
    }), 400)

}

async function getPublications(page){

    const params = new FormData()

    params.append('action', 'leo_get_publications')
    params.append('page', page)

    const response = await jsonFetch(kreenoot_child.ajax_url, {
        method: 'POST',
        body: params,
    })

    if(response.success) {
        
        container.innerHTML += response.data
        loading = false
        loader.classList.remove('active')

                    
        let btnCard = document.querySelectorAll('.leo-card__btn');

        btnCard?.forEach(function (btn) {
            btn.addEventListener('click', function () {
                btn.classList.toggle('leo-card__btn--active')
                let abstract = btn.nextElementSibling;
                abstract.classList.toggle('leo-card__abstract--active');
            })
        })
    }
}
